import { Link } from "react-router-dom";
import IfRender from "@/components/IfRender";
import icEdit from './icEdit.png'
import icDelete from './icDelete.png'
import s from './index.module.css'
import { AddressInfo } from '@/service/address'
import { getUrlSearchValue } from '@/utils'
interface IProps {
  address: AddressInfo,
  onDelete: (id: number) => void,
  onOK: (id: AddressInfo) => void,
  id: number
}

const Card = ({
  address,
  onDelete,
  onOK,
  id
}: IProps) => {

  const { studentId } = getUrlSearchValue()

  const { name,
    mobile,
    province,
    city,
    area,
    address: addressDetail,
    default: isDefault,
  } = address
  return (
    <div className={s.container}>
      <div className={s.title}>
        <p>{name}</p>
        <div>
          {
            isDefault ? (
              <span
                className={s.defaultAddress}
              >
                默认地址
              </span>
            ) : null
          }
        </div>
      </div>
      <div className={s.addressInfo}>
        <p><span>手机号码:</span>{mobile}</p>
        <p><span>所在地区:</span>{province} {city} {area}</p>
        <p><span>收货人信息: </span>{addressDetail}</p>
      </div>
      <div className={s.operation}>
        <Link
          to={`/address/edit/${id}${location.search}`}
          state={{ address }}
        >
          <div className={`${s.operateBtn} border-all-1px`}>
            <img
              src={icEdit}
              alt={''}
              className={s.operateIcon}
            />
            <div>编辑</div>
          </div>
        </Link>
        <IfRender show={!studentId}>
          <div
            onClick={(e) => { e.stopPropagation(); onDelete(id) }}
            className={`${s.operateBtn} border-all-1px`}
          >
            <img
              src={icDelete}
              alt={''}
              className={s.operateIcon}
            />
            <div>删除</div>
          </div>
        </IfRender>
        <div
          onClick={(e) => { e.stopPropagation(); onOK(address) }}
          className={`${s.operateBtn} border-all-1px`}
        >
          <div>确定</div>
        </div>
      </div>
    </div>
  )
}


export default Card
